import { Time } from '@tencent/odc-iconpack';
import React from 'react';

import './index.scss';

const GetInTouchWaiting = () => {
  return (
    <div className="odc-page-waiting">
      <Time />
      <div className="title">Your request is under review.</div>
      <div className="description">Thank you for your interest in AdSurge. Our team will reach out to you once your access is approved.</div>
    </div>
  );
};

export default GetInTouchWaiting;